import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/videos";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % heroSlides.length);
    }, 6500);
    return () => window.clearInterval(timer);
  }, []);

  const active = heroSlides[index];

  const goTo = (next: number) => {
    setIndex((next + heroSlides.length) % heroSlides.length);
  };

  return (
    <section className="relative w-full overflow-hidden bg-primary-950" aria-label="焦点视频推荐">
      <div className="relative h-[560px] w-full md:h-[660px]">
        {heroSlides.map((slide, slideIndex) => (
          <div
            key={slide.videoId}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              slideIndex === index ? "opacity-100" : "opacity-0"
            }`}
            aria-hidden={slideIndex !== index}
          >
            <img
              src={slide.image}
              alt={`${slide.headline} 焦点专题图`}
              title={`${slide.headline} - 赛事黑榜焦点`}
              className={`h-full w-full object-cover object-top ${slideIndex === index ? "anim-slow-zoom" : ""}`}
            />
          </div>
        ))}

        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/70 to-foreground-950/25" />
        <div className="absolute inset-x-0 bottom-0 h-[30%] bg-gradient-to-t from-background-50 via-background-50/55 to-transparent" />

        <div className="container-page relative z-10 flex h-full flex-col justify-center pb-16 pt-28 md:pb-20 md:pt-24">
          <div className="max-w-2xl">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-semibold text-primary-950">
                <i className="ri-flashlight-fill text-sm" />
                每日黑榜
              </span>
              <span className="font-label text-[11px] tracking-[0.26em] text-background-200">
                每日 08:00 更新 · 已更新 {heroSlides.length} 期焦点
              </span>
            </div>

            <h1 className="mt-5 text-[30px] font-black leading-[1.18] text-background-50 md:text-[46px] md:leading-[1.15]">
              每日大赛今日黑榜
              <br className="hidden md:block" />
              精选赛事视频一站看全
            </h1>

            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-[15px]">
              收录足球、篮球、电竞、赛车与综合赛事的每日黑榜片段，按类别、时间段与比赛等级归档，随时回看每一场关键失误。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link to={`/detail/${active.videoId}`} className="btn-accent h-11 px-6 text-[14px]">
                查看本期黑榜
                <i className="ri-arrow-right-line text-base" />
              </Link>
              <Link
                to="/category/football"
                className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 text-sm font-medium text-background-50 transition-colors hover:border-background-50 hover:bg-background-50/10"
              >
                浏览全部分类
              </Link>
            </div>
          </div>

          <div className="mt-10 hidden max-w-2xl items-center gap-4 border-l-2 border-accent-500 pl-4 md:flex">
            <div className="min-w-0">
              <p className="font-label text-[11px] tracking-[0.28em] text-accent-300">{active.kicker}</p>
              <Link
                to={`/detail/${active.videoId}`}
                className="mt-1 block truncate text-[15px] font-semibold text-background-50 transition-colors hover:text-accent-300"
              >
                {active.headline}
              </Link>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 right-4 z-20 flex items-center gap-3 md:right-8">
          <div className="flex items-center gap-1.5">
            {heroSlides.map((slide, slideIndex) => (
              <button
                key={slide.videoId}
                type="button"
                aria-label={`切换至第 ${slideIndex + 1} 张焦点图`}
                onClick={() => goTo(slideIndex)}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  slideIndex === index ? "w-7 bg-accent-500" : "w-2.5 bg-background-50/45 hover:bg-background-50/70"
                }`}
              />
            ))}
          </div>
          <span className="font-label text-[11px] tracking-widest text-background-100">
            {String(index + 1).padStart(2, "0")} / {String(heroSlides.length).padStart(2, "0")}
          </span>
          <div className="flex items-center gap-1">
            <button
              type="button"
              aria-label="上一张"
              onClick={() => goTo(index - 1)}
              className="flex h-8 w-8 items-center justify-center rounded-full border border-background-50/35 text-background-50 transition-colors hover:border-background-50 hover:bg-background-50/10"
            >
              <i className="ri-arrow-left-s-line" />
            </button>
            <button
              type="button"
              aria-label="下一张"
              onClick={() => goTo(index + 1)}
              className="flex h-8 w-8 items-center justify-center rounded-full border border-background-50/35 text-background-50 transition-colors hover:border-background-50 hover:bg-background-50/10"
            >
              <i className="ri-arrow-right-s-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}